import { render, staticRenderFns } from "./AccessibleSnackbar.vue?vue&type=template&id=78b0233d"
import script from "./AccessibleSnackbar.vue?vue&type=script&lang=js"
export * from "./AccessibleSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports